import { Translation } from "../model/Translation";
import axiosInstance from "../utils/ApiUtils/axiosInstance";

export const forceReviewedStatus = async (translationId: number): Promise<Translation | null> => {
  const response = await axiosInstance.post<ApiResponse<Translation>>(`/api/translation/force/review/${translationId}`);
  return response.data.data;
};
